import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "../button/constants";
export function template() {
  const {
    visibility
  } = this.state;
  return /* @__PURE__ */ jsx("div", { sel: ".mp-modal", class: {
    "is-closed": this.helpers.isClosed(),
    "is-fullscreen": !this.attr("not-fullscreen"),
    ["is-".concat(this.attr("modal-type"))]: true,
    "mp-modal-sliding": this.attr("sliding-transition")
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.helpers.showBackdrop() ? /* @__PURE__ */ jsx("div", { sel: ".mp-modal-backdrop", class: {
    ["is-".concat(visibility)]: true
  }, on: {
    mousedown: this.helpers.handleBackdropClick
  } }) : null, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-wrapper", attrs: {
    elref: "contentBody"
  }, class: {
    ["is-".concat(this.attr("modal-type"))]: true,
    ["is-".concat(this.attr("vertical-alignment"), "-aligned")]: true,
    ["is-".concat(visibility)]: true
  }, on: {
    mousedown: this.helpers.handleBackdropClick
  } }, /* @__PURE__ */ jsx("div", { sel: ".mp-modal-main", class: {
    ["is-".concat(this.attr("modal-type"))]: true,
    "is-variable-width": this.attr("grow-to-content"),
    "has-background": !this.attr("hide-background")
  }, attrs: {
    role: "dialog",
    "aria-labelledby": this.attr("modal-title"),
    "aria-describedby": this.attr("modal-description"),
    "aria-modal": true
  }, on: {
    mousedown: (ev) => ev.stopPropagation()
  } }, (this.attr("closeable") || this.attr("modal-type") === "tour-modal") && !this.attr("hide-close-button") ? /* @__PURE__ */ jsx(ButtonEl, { sel: ".mp-modal-close-button", attrs: {
    elref: "closeModalButton",
    theme: ButtonTheme.Tertiary,
    icon: "x"
  }, class: {
    "close-button-padded": this.attr("close-button-padded")
  }, on: {
    click: this.helpers.handleCloseClick
  } }) : null, /* @__PURE__ */ jsx("slot", { "data-sentry-element": "slot", "data-sentry-source-file": "template.tsx" }))));
}
